// 9fbef606107a605d69c0edbcd8029e5d

const GYM_LOGO = 'gymboree-logo.svg';

export default {
  'footer__social-link--fb': 'facebook_3x.png',
  'footer__social-link--tw': 'twitter_3x.png',
  'footer__social-link--ig': 'instagram_3x.png',
  'footer__social-link--pt': 'pinterest_3x.png',
  'footer__social-link--yt': 'youtube_3x.png',
  'footer__social-link--tt': 'tiktok_3x.png',
  'footer__social-link--sc': 'snapchat_3x.png',
  // TODO - Remove the header__promo-text-banner when the styles start coming up from CMS
  'header__promo-text-banner': 'at-icon.svg',
  'blue-email': 'at-icon.svg',
  'green-dollar': 'dollar-sign-icon.svg',
  'orange-schedule': 'clock-icon.svg',
  'icon-carrot-grey-large': 'carrot-icon-grey.svg',
  'icon-carrot-black-small': 'carrot-small-black.svg',
  'icon-carrot-white': 'carrot-icon-white.svg',
  'icon-done': 'done.png',
  'footer__mpr-container--col1': 'mp-rewards-orange.png',
  'footer__mpr-container--col1-CA': 'airmiles-logo.png',
  'footer__mpr-container--col2': 'mp-rewards-blue.png',
  'header__brand-tab-tcp': 'tcp-logo.svg',
  'header__brand-tab-gym': GYM_LOGO,
  'header__brand-tab--tcp': 'tcp-logo.svg',
  'header__brand-tab--tcp-blue': 'TCP-blue-logo.svg',
  'header__brand-tab-gymboree': GYM_LOGO,
  'header__brand-tab-gymboree-blue': 'GYM-blue-logo.svg',
  'header__brand-tab--tcp-alt': 'tcp-logo-alt.svg',
  'header__brand-tab-gymboree-alt': 'gymboree-logo-alt.svg',
  'header__brand-tab-snj': 'snj-logo.svg',
  'header__brand-tab-snj-blue': 'SNJ-blue-logo.svg',
  'header__brand-tab-snj-alt': 'snj-logo-alt.svg',
  'header__brand-tab-pjp': 'pjp-logo.svg',
  'header__brand-tab-pjp-blue': 'PJP-blue-logo.svg',
  'header__brand-tab-pjp-alt': 'pjp-logo-alt.svg',
  'header__brand-tab-quad': 'quad-logo-horizontal.svg',
  'icon-play': 'play.svg',
  'icon-pause': 'pause.svg',
  'gift-card-icon': 'gift-card-small.png',
  'icon-card-smile': 'card-smile.png',
  'credit-card': 'credit-card.png',
  credit_card: 'credit_card.svg',
  'gift-card': 'gift-card.png',
  gift_card: 'gift_card.svg',
  'disc-small': 'discover.svg',
  'discover-small': 'discover.svg',
  'mc-small': 'mastercard.svg',
  'master-card-small': 'mastercard.svg',
  'amex-small': 'amex.svg',
  'apple-pay-icon': 'apple_pay.svg',
  'after-pay-icon': 'after_pay.svg',
  'placecard-small': 'tcp-cc_2x.png',
  Afterpay_Badge_BlackonMint: 'Afterpay_Badge_BlackonMint.svg',
  'place-card-small': 'tcp-cc_2x.png',
  'place-card-pjp-small': 'pjp-cc_2x.png',
  'visa-small': 'visa.svg',
  'visa-bordered': 'visa-bordered.svg',
  'venmo-bordered': 'venmo-bordered.svg',
  'gift-card-small': 'tri_brand_gift_card_no_shadow.png',
  'gift-card-two-brand': 'two_brand_gift_card.svg',
  'GIFT-CARD-MODAL': 'GIFT-CARD-MODAL.svg',
  'venmo-blue-acceptance-mark': 'venmo.svg',
  'my-place-rewards': 'my-place-rewards.png',
  'my-place-rewards-single-line': 'my-place-rewards-single-line.svg',
  'info-icon': 'info-icon.png',
  down_arrow_icon: 'carrot-small-down.png',
  down_arrow_icon_white: 'carrot-small-down-white.png',
  up_arrow_icon: 'carrot-small-up.png',
  up_arrow_icon_blue: 'up-arrow-blue.png',
  down_arrow_icon_blue: 'down-arrow-blue.png',
  down_arrow_toggle: 'down-arrow-toggle.svg',
  up_arrow_toggle: 'up-arrow-toggle.svg',
  active_icon: 'circle-check.png',
  'circle-alert-fill': 'circle-alert-fill.svg',
  'item-returned': 'item-returned.svg',
  'item-returned-filled': 'item-returned-filled.svg',
  'item-canceled': 'item-canceled.svg',
  'item-refunded': 'item-refunded.svg',
  'circle-green-check': 'circle-check-green.svg',
  'circle-check-fill': 'circle-check-fill.png',
  'circle-check-form-icon': 'icon-checkmark.svg',
  'circle-error-fill': 'circle-error-fill.png',
  'circle-warning-fill': 'circle-warning-fill.png',
  'circle-info-fill': 'circle-info-fill.svg',
  'circle-info-blue': 'circle-info-blue.svg',
  'circle-info-orange': 'circle-info-orange.svg',
  'circle-info-red': 'circle-info-red.svg',
  'circle-info-white': 'circle-info-white.svg',
  'carousel-big-carrot': 'right-carousel-carrot.svg',
  'family-outfit-arrow': 'family-outfit-arrow.svg',
  'family-outfit-disabled-arrow': 'family-outfit-disabled-arrow.svg',
  'right-disable-carousel-carrot': 'right-disable-carousel-carrot.svg',
  'dotted-line': 'dotted-line.png',
  rightarrow: 'rightarrow.png',
  smallright: 'smallright.svg',
  superstar: 'superstar.svg',
  'carousel-big-carrot-left': 'left-carousel-carrot.svg',
  'carousel-big-carrot-white': 'right-carousel-carrot-white.svg',
  // TODO - Remove the fav_icon when the vector Icons would be implemented
  'fav-icon': 'heart.png',
  'empty-fav-icon': 'empty-heart.png',
  'error-message-icon': 'error-message-icon.svg',
  'icon-chat': 'comments_feedback.svg',
  'icon-alarm': 'icon-alarm_2x.png',
  'icon-bell': 'bell.svg',
  'icon-chat-gray': 'icon-chat-gray_2x.png',
  'icon-alarm-gray': 'icon-alarm-gray_2x.png',
  'cart-icon': 'bag.png',
  'cart-icon-tcp': 'bag-tcp.svg',
  'cart-icon-gym': 'bag-gym.svg',
  'cart-icon-snj': 'bag-snj.svg',
  'cart-icon-blue': 'bag-icon-blue.svg',
  'marker-icon': 'store_locator.svg',
  'fast-shipping': 'shipping.svg',
  'shipping-section': 'shipping-section.svg',
  'pickup-section': 'pickup.svg',
  'no-rush-section': 'no-rush.svg',
  'in-transit.svg': 'in-transit.svg',
  'marker-icon-blue': 'marker-icon-blue.svg',
  'cart-icon-1': 'bag.svg',
  'cart-icon-2': 'bag-2.svg',
  'cart-icon-3': 'bag-3.svg',
  'alert-triangle': 'alert-triangle.png',
  'user-icon': 'user-icon.png',
  'user-icon-tcp': 'user-icon-tcp.svg',
  'user-icon-gym': 'user-icon-gym.svg',
  'user-icon-snj': 'user-icon-snj.svg',
  'user-icon-gray': 'user-icon.svg',
  'user-icon-blue': 'user-icon-blue.svg',
  'user-icon-black': 'user-icon-black.svg',
  'selected-item': 'selected-item.svg',
  'selected-item-check-no-circle': 'circle-check-no-circle.svg',
  'checkout-tick': 'checkout-step-complete.svg',
  'tick-mark-black': 'tick-mark-black.svg',
  'gift-card-icon-white': 'gift-card-icon.svg',
  'checkout-white-dot': 'checkout-white-dot.svg',
  'carrot-large-left': 'carrot-large-left.png',
  'close-icon': 'large.png',
  'close-cross': 'close-cross.svg',
  'close-cross-red': 'close-cross-red.svg',
  plus: 'plus.svg',
  'plus-icon': 'plus.png',
  'plus-icon-thick': 'plus-thick.png',
  'minus-icon': 'minus.svg',
  'mailing-address-icon': 'mailingAddress.svg',
  'fav-store-icon': 'store.svg',
  'birthday-icon': 'birthdays.svg',
  'survey-icon': 'survey.png',
  'feedback-survey-icon': 'feedback_survey.svg',
  'smiley-icon': 'smiley-icon.png',
  'carrot-left': 'carrot-left.png',
  'carrot-left-light-gray': 'carrot-left-light-gray.svg',
  favourites: 'favourites.svg',
  favourites_solid: 'favourites_solid.svg',
  'favorites-bag-icon': 'favorites-bag-icon.svg',
  'paypal-icon': 'paypal.svg',
  'cross-icon': 'small.png',
  'girl-icon': 'girl.svg',
  'boy-icon': 'boy.svg',
  star: 'star.svg',
  'star-filled': 'star-filled.svg',
  'star-filled-yellow': 'star-filled-yellow.svg',
  'star-icon': 'star.png',
  'circle-check': 'circle-check.svg',
  'dot-email-orange': 'dot-email-orange.svg',
  'dot-email-blue': 'dot-email-blue.png',
  'chat-blue': 'chat-blue.png',
  'chat-orange': 'chat-orange.svg',
  'search-icon': 'search_glass.svg',
  'search-icon-blue': 'search-icon-blue.svg',
  'search-close-icon': 'search-close-icon.svg',
  'venmo-button': 'venmo_white_logo.svg',
  'gymboree-icon': GYM_LOGO,
  'venmo-logo-blue': 'venmo_logo_blue.png',
  'sample-receipt': 'sample-receipt.png',
  'cart-icon-white': 'white-bag.svg',
  'shopping-bag-overlay': 'shopping-bag-overlay.svg',
  'facebook-icon': 'facebook_2x.png',
  'facebook-share': 'facebook_share.png',
  'twitter-icon': 'twitter_2x.png',
  'pinterest-icon': 'pinterest_2x.png',
  'tiktok-icon': 'tiktok_2x.png',
  'tick-green': 'tick_green.svg',
  'youtube-icon': 'youtube_2x.png',
  'facebook-black': 'facebook-black.svg',
  'twitter-black': 'twitter-full-black.svg',
  'pinterest-black': 'pinterest-black.svg',
  'icon-printer': 'icon-printer.png',
  'modules-s-left-ribbon': 'module-s-left-ribbon.png',
  'modules-s-right-ribbon': 'module-s-right-ribbon.png',
  'icon-expand': 'icon-expand.svg',
  'img-placeholder': 'img-placeholder.png',
  'medium-left-arrow': 'medium-left-arrow.svg',
  'facebook-color-icon': 'facebook_3x.png',
  'instagram-color-icon': 'instagram_3x.png',
  'twitter-color-icon': 'twitter_2x.png',
  'facebook-fade-color-icon': 'facebook-fade_2x.png',
  'instagram-fade-color-icon': 'instagram-fade_2x.png',
  'twitter-fade-color-icon': 'twitter-fade_2x.png',
  'push-disabled': 'push-disabled.svg',
  'sms-disabled': 'sms-disabled.svg',
  'push-enabled': 'push-enabled.svg',
  'sms-enabled': 'sms-enabled.svg',
  'app-store': 'app-store-logo.png',
  'google-play': 'google-play-badge.svg',
  'header-icon__heart': 'heart-icon.png',
  'confirmation-check': 'confirmation_check.svg',
  'modal-close': 'modal-close.svg',
  'mobile-close-dark': 'mobile-close-dark.svg',
  'grey-menu': 'grey-menu.svg',
  menu: 'menu.svg',
  'down-arrow-sitemap': 'down-arrow-sitemap.png',
  'venmo-app-icon': 'venmo-app-icon.png',
  'essential-style-fallback': 'fallback.png',
  'essential-style-fallback-selected': 'fallback-selected.png',
  'white-cross-icon': 'white-cross-icon.png',
  'stars-rating': 'stars-rating.png',
  'tcp-smart-banner-icon': 'tcp_app.png',
  'gym-smart-banner-icon': 'gym_app.png',
  'snj-smart-banner-icon': 'snj_app.png',
  'pjp-smart-banner-icon': 'pjp_app.png',
  'circle-check-green': 'circle-check-green.png',
  'check-green': 'circle-check-no-circle-green.svg',
  'tcp-gym-black-logo': 'TCP_GYM_Logos_Horizontal_BLK.jpg',
  'header__brand-tab--tcp-png': 'tcp-logo.png',
  'header__brand-tab-gymboree-png': 'gymboree-logo.png',
  gift_guide_sm: 'gift_guide.png',
  gift_guide_md: 'gift_guide_2x.png',
  gift_guide_lg: 'gift_guide_3x.png',
  'help-chat_sm': 'icon-icon-chat-feedback_3x.png',
  'help-chat_white': 'icon-icon-chat-feedback.svg',
  'card-payment-logo': 'add-card-payment.svg',
  'no-order': 'no-order.png',
  'under-review': 'refund-under-review.svg',
  'call-help': 'call-help.svg',
  'chat-help': 'chat-help.svg',
  'email-help': 'email-help.svg',
  'triangle-warning': 'triangle-warning.svg',
  'wallet-green': 'wallet-green.png',
  'triangle-alert': 'triangle-alert.svg',
  'order-delivered': 'delivered.svg',
  'order-delivered-filled': 'order-delivered-filled.svg',
  'order-partially-cancelled': 'partially-cancelled.svg',
  'order-pickup': 'pickup-lg.svg',
  'status-shipping-cancelled': 'shipping-cancelled.svg',
  'status-shipping-icon': 'shipping-lg.svg',
  my_place_reward: 'my-place-rewards.svg',
  'my-place-rewards-checkout': 'my-place-rewards-checkout.svg',
  'circle-close-blue': 'circle-close-blue.png',
  'question-circle': 'question-circle.svg',
  package: 'package.svg',
  'info-icon-blue': 'info-icon-blue.svg',
  'in-progress': 'in-progress.svg',
  'blue-sms-icon': 'smsblue.png',
  'black-sms-icon': 'smsblack.png',
  arrowWithBg: 'btn-arrow-left-bg.svg',
  'in-transit': 'Shipped.svg',
  'return-initiated': 'order-returns.svg',
  'out-for-delivery': 'Out_for_delivery.svg',
  shipped: 'Shipped.svg',
  'ready-for-pickup': 'Ready_for_Pickup.svg',
  'processing-preparing': 'Processing_preparing.svg',
  'gift-services': 'gift-services.svg',
  'mybag-gift-services': 'mybag-gift-services.svg',
  'dollar-icon': 'dollar.svg',
  'icons-error-message': 'icons-error-message.png',
  'icons-warning-message': 'icons-warning-message.png',
  'discover-card-icon': 'discover.jpg',
  'discover-card': 'discover.png',
  'snj-smiley-icon': 'smiley.svg',
  'plus-line': 'plus-line.png',
  'order-returned-filled': 'order-returned-filled.svg',
  'add-gift-card': 'add-gift-card.svg',
  'add-gift-card-without-plus': 'gift-card2.svg',
  'size-chart-ruler': 'ruler-copy.svg',
  'size-chart-right-arrow': 'icons-elements-carets-medium-medium-left.svg',
  'standard-shipping': 'icons-standard-shipping.svg',
  'location-icon-blue': 'icons-standard-store-locator-blue.svg',
  'location-icon': 'store_locator.svg',
  'standard-shipping-blue': 'icons-standard-shipping-blue.svg',
  'cc-plcc-icon': 'cc_card_2x.png',
  'left-arrow-icon': 'left-arrow-icon.svg',
  'arrow-right-small': 'arrow-right-small.svg',
  'share-icon': 'icons-standard-share-ios.png',
  'share-icon-2x': 'icons-standard-share-ios_2x.png',
  'share-icon-3x': 'icons-standard-share-ios_3x.png',
  'share-icon-snj': 'share-icon-snj.png',
  'complete-my-look': 'complete-my-look.png',
  'fav-icon-snj': 'fav-icon-snj.png',
  'fav-icon-fill-snj': 'fav-icon-fill-snj.png',
  'fav-icon-outline': 'fav-icon-outline.png',
  'fav-icon-solid': 'fav-icon-solid.png',
  'fav-icon-pjp': 'fav-icon-pjp.svg',
  'fav-icon-fill-pjp': 'fav-icon-fill-pjp.svg',
  standard_clothes_3x: 'icons_standard_clothes_3x.png',
  'edit-icon': 'edit-review.svg',
  'save-for-later-icon': 'save-for-later.svg',
  'hamburger-icon': 'hamburger.svg',
  'store-star': 'store-star.svg',
  'favStore-icon': 'fav-storeicon.svg',
  'bag-close-icon': 'bag_close.svg',

  'bag-ship-to-home-blue': 'bag_normaldelivery-blue.svg',
  'bag-ship-to-home-black': 'bag_normaldelivery.svg',
  'bag-free-gift': 'gift.svg',
  'bag-no-rush-blue': 'bag_norushpickup-blue.svg',
  'bag-no-rush-black': 'bag_norushpickup.svg',

  'plus-icon-family-outfit': 'plusIcon.svg',
  'carrot-large-right': 'carrot-large-right.svg',
  'toggle-right-arrow': 'toggle-right-arrow.svg',
  'toggle-left-arrow': 'toggle-left-arrow.svg',
  'bag-pick-up-today-blue': 'bag_pickuptoday-blue.svg',
  'bag-pick-up-today-black': 'bag_pickuptoday.svg',
  'place-bucks': 'place-bucks.svg',
  'elements-plcc-card': 'elements-plcc-card_3x.png',
  'my-place-rewards-credit-card': 'my-place-rewards-credit-card.svg',
  'PLCC-Card-Logo': 'PLCC-Card-Logo.svg',
  'plcc-transit': 'transit.svg',
  'apple-pay-logo': 'Apple_Pay_logo.svg',
  'paypal-logo': 'paypal_logo.svg',
  'venmo-logo': 'venmo-logo.svg',
  'tick-mark': 'tick-mark.svg',
  'expired-icon': 'expired-icon.png',
  'filter-1': 'blackFilter.svg',
  accessoryAddIcon: 'images/btn-circle-plus-blue.svg',
  accessoryRemoveIcon: 'images/roundBlueRemoveButton.svg',
  accessoryViewIcon: 'images/view.svg',
  'search-magnifying-glass': 'search-magnifying-glass.png',
  filter: 'filter.svg',
  'fav-facebook': 'fav-facebook.png',
  'fav-email': 'fav-email.png',
  'fav-copylink': 'fav-copylink.png',
  sort: 'sort.svg',
  blackFilter: 'blackFilter.svg',
  whiteSort: 'whiteSort.svg',
  snjMoon: 'Sugar_Jade_logo_moon.svg',
  'selected-tcp': 'selected-item-check.svg',
  'shop-this-store': 'shop-this-store-icon.svg',
  'cta-search': 'cta-search.svg',
  'right-arrow': 'right.svg',
  'alert-icon': 'alert.svg',
  'add-to-bag': 'add-to-bag-icon.svg',
  'add-to-bag-icon-blue': 'add-to-bag-icon-blue.svg',
  'earning-points': 'earning-points.svg',
  birthday: 'birthday.svg',
  'buy-it-again': 'buy-it-again.svg',
  'create-your-account': 'create-your-account.svg',
  'credit-card-icon': 'credit-card-icon.svg',
  'download-app': 'download-app.svg',
  'gift-card-icon-small': 'gift-card-icon-small.svg',
  location: 'location.svg',
  'mailing-address': 'mailing-address.svg',
  'my-favourites': 'my-favourites.svg',
  'my-place-rewards-icon': 'my-place-rewards-icon.svg',
  'offers-wallet': 'offers-wallet.svg',
  orders: 'orders.svg',
  'pay-my-bill': 'pay-my-bill.svg',
  profile: 'profile.svg',
  'rate-and-review': 'rate-and-review.svg',
  'sign-out': 'sign-out.svg',
  store: 'store.svg',
  'text-alerts': 'text-alerts.svg',
  'alt-plp-cart-icon-tcp': 'Alternate-PLP-Shopping-Add-TCP.svg',
  'alt-plp-cart-icon-gym': 'Alternate-PLP-Shopping-Add-GYM.svg',
  'alt-plp-cart-icon-snj': 'Alternate-PLP-Shopping-Add-SNJ.svg',
  'alt-plp-cart-icon-pjp': 'Alternate-PLP-Shopping-Add-PJPlace.svg',
  'circle-alert-fill-red': 'circle-alert-fill-red.svg',
  'circle-alert-fill-yellow': 'circle-alert-fill-yellow.svg',
  'circle-check-fill-green': 'circle-check-fill-green.svg',
  'add-a-gift-card': 'add-a-gift-card.svg',
  'add-a-credit-card': 'add-a-credit-card.svg',
  gift_service_standard_tcp: 'gift_service_standard_tcp.png',
  gift_service_deluxe_tcp: 'gift_service_deluxe_tcp.png',
  gift_service_standard_snj: 'gift_service_standard_snj.png',
  gift_service_deluxe_snj: 'gift_service_deluxe_snj.png',
  gift_service_standard_gym: 'gift_service_standard_gym.png',
  gift_service_deluxe_gym: 'gift_service_deluxe_gym.png',
  gift_service_standard_pjp: 'gift_service_standard_pjp.png',
  gift_service_deluxe_pjp: 'gift_service_deluxe_pjp.png',
  rewards: 'rewards.svg',

  'place-perks-start-bg': 'place-perks-start-bg.svg',
  'place-perks-right-arrow': 'place-perks-right-arrow..svg',
  'place-perks-left-arrow': 'place-perks-left-arrow.svg',
  'place-perks-suprise-coupon-every-month': 'place-perks-suprise-coupon-every-month.svg',
  'place-perks-tick': 'place-perks-tick.svg',
  'place-perks-double-point-day': 'place-perks-double-point-day.svg',
  'place-perks-shipping': 'place-perks-shipping.svg',
  'place-perks-free-delux-gift-reward': 'place-perks-free-delux-gift-reward.svg',
  'place-perks-small-star': 'place-perks-small-star.svg',
  'place-perks-new-small-star': 'place-perks-new-small-star.svg',
  'mega-star-congrats-icon': 'mega-star-congrats-icon.svg',
  'place-perks-star-solid': 'place-perks-star-solid.svg',
  'rewards-status-star': 'rewards-status-star.svg',
  'sts-cta': 'sts-cta.svg',
  'sms-survey': 'sms-survey.svg',
  'sign-up-for-email': 'sign-up-for-email.svg',
  'survey-lock': 'survey-lock.svg',
  hamburgerFav: 'hamburger-fav.svg',
  hamburgerMarkerIcon: 'hamburger-marker-icon.svg',
  transparentFavIcon: 'transparentFavIcon.png',
  blackFavIcon: `blackFavIcon.png`,
  markerIcon: 'marker-icon.png',
  hamburgerOrders: 'hamburger-orders.svg',
  'cart-social-proofing': 'cart-social-proofing.svg',
  'cart-social-proofing-blue': 'cart-social-proofing-blue.svg',
  'cart-social-proofing-tag-icon': 'cart-social-proofing-tag-icon.svg',
  'cart-social-proofing-purchase-icon': 'cart-social-proofing-purchase-icon.svg',
  'cart-social-proofing-gift-icon': 'cart-social-proofing-gift-icon.svg',
  'white-lock-icon': 'white-lock-icon.svg',
  'twitter-grey': 'twitter-grey.svg',
  'pinterest-grey': 'pinterest-grey.svg',
  'facebook-grey': 'facebook-grey.svg',
  'added-to-fav': 'added-to-fav.svg',
  'savings-offer-icon': 'savings-offer-icon.svg',
  'star-icon-white': 'star-icon-white.svg',
  'venmo-logo-blue-no-space': 'venmo-logo-blue.png',
  'afterpay-logo-white': 'afterpay_logo_white.png',
  'afterpay-badge-blackonmint': 'afterpay-badge-blackonmint.png',
  'dropdown-icon': 'dropdown.svg',
  'save-for-later-icon-black': 'save-for-later-icon-black.svg',
  'edit-icon-black': 'edit-icon-black.svg',
  'hamburger-icon-black': 'hamburger-icon-black.svg',
  'icon-remove': 'icon-remove.svg',
  placebucks_plcc: 'placebucks_plcc.svg',
  stars_plcc: 'stars_plcc.svg',
  blue_stars_plcc: 'blue-star.svg',
  plcc_cc_icon: 'plcc-icon-pdp.svg',
  'right-arrow-plcc': 'caret_icon.svg',
  'fav-heart': 'fav-heart.svg',
  'afterpay-logo-black': 'afterpay-logo-black.svg',
  mpr_icon: 'mpr-icon.svg',
  'footer__social-link--fb-new': 'facebook.svg',
  'footer__social-link--tw-new': 'twitter.svg',
  'footer__social-link--ig-new': 'instagram.svg',
  'footer__social-link--pt-new': 'pinterest.svg',
  'footer__social-link--yt-new': 'youtube.svg',
  'footer__social-link--tt-new': 'tiktok.svg',
  'store-special-shipping': 'shipping2.svg',
  'store-special-pin': 'specialstorepin.svg',
  'store-special-store': 'store.svg',
  'chevron-right': 'chevron-right.svg',
  'plus-circle': 'plus-circle.svg',
  'minus-circle': 'minus-circle.svg',
  'white-close-icon': 'white-close-icon.png ',
  'orange-circle-white-info': 'orange-circle-white-info.svg',
  'cashapp-afterpay-logo-black': 'cashapp-logo-black.png',
  'cashapp-afterpay-logo-white': 'cashapp-logo-white.png',
  'view-map-icon': 'map.svg',
  'tcp-header-logo-multiline': 'tcp-header-logo-multiline.svg',
  'tcp-header-logo-black-and-white': 'tcp-header-logo-black-and-white.svg',
  'tcp-header-logo': 'tcp-header-logo.svg',
  'cross-icon-black': 'cross-icon-black.svg',
  'tcp-header-logo-active': 'tcp-header-logo-active.svg',
  'gym-header-logo-active': 'gym-header-logo-active.svg',
  'gym-header-logo-small': 'gym-header-logo-small.svg',
  'gym-header-logo-inactive': 'gym-header-logo-inactive.svg',
  'gym-header-logo': 'gym-header-logo.svg',
  'hamburger-header-black': 'hamburger-header-black.svg',
  'gym-header-logo-black-and-white': 'gym-header-logo-black-and-white.svg',
  'tcp-header-logo-inactive': 'tcp-header-logo-inactive.svg',
  'noun-star': 'noun-star.svg',
  tier: 'tier.svg',
  'filter-black': 'filter-black.svg',
  'bonus-event': 'bonus-event.svg',
  'birthday-gift': 'birthday-gift.svg',
  'gift-wrap': 'gift-wrap.svg',
  glow: 'glow.svg',
  milestone: 'milestone.svg',
  'tier-star': 'tier-star.svg',
  'tier-filled-star': 'tier-filled-star.svg',
  'plcc-card': 'Pink-plcc-card.svg',
  'app-dowanload': 'app-dowanload.svg',
  'home-with-heart': 'home-with-heart.svg',
  'facbook-outline': 'facbook-outline.svg',
  'envelope-open': 'envelope-open.svg',
  'child-avatar': 'child-avatar.svg',
  'comment-lines': 'comment-lines.svg',
  'birthday-cake': 'birthday-cake.svg',
  'arrow-right-circle': 'arrow-right-circle.svg',
  review: 'review.svg',
  'sms-ring': 'sms-ring.png',
  'blue-line-star': 'blue-line-star.svg',
  'milestone-gift': 'milestone-gift.svg',
  'shopping-bag': 'shopping-bag.svg',
  'color-star': 'color-star.svg',
  X: 'X.svg',
  'store-event': 'store-event.svg',
  'early-access': 'early-access.svg',
  'expedited-order': 'expedited-order.svg',
  'users-defined': 'users-defined.svg',
  'free-gift-wrap': 'free-gift-wrap.svg',
  'loyalty-birthday-cake': 'loyalty-blue-BIrthday.svg',
  'bonus-points': 'bonus-points.svg',
  'benefit-check': 'benefit-check.svg',
  'tier-1': 'tier-1.svg',
  'tier-2': 'tier-2.svg',
  'task-completed': 'Task-Completed.svg',
  'buy-again': 'Buy_it_Again.svg',
  'track-order': 'track-order.svg',
  'account-dashboard': 'user.svg',
  'place-reward': 'black-star.svg',
  'earn-rewards': 'earn-rewards.png',
  'member-gifts': 'member-gifts.png',
  'special-offers': 'special-offers.png',
  'chevron-right-dark': 'chevron-right-dark.svg',
  'info-gray-icon': 'info-gray-icon',
  'loyalty-log-out': 'log-out.svg',
  'loyalty-my-fav': 'Fav.svg',
  'loyalty-credit-card': 'loyalty-credit-dard.svg',
  'chevron-down-gray': 'chevron-down-gray.svg',
  'reward-info-dark': 'reward-info-dark.svg',
  'loyalty-place-reward-header': 'MPR-TEXT-LOGO.svg',
  'bonus-event-tier-1': 'bonus-event-tier-1.svg',
  'bonus-event-tier-2': 'bonus-event-tier-3.svg',
  'bonus-event-tier-3': 'bonus-event-tier-2.svg',
  'gift-wrap-tier-1': 'gift-wrap-tier-1.svg',
  'gift-wrap-tier-2': 'gift-wrap-tier-3.svg',
  'gift-wrap-tier-3': 'gift-wrap-tier-2',
  'Benefits-Sparkle-tier-1': 'Benefits-Sparkle-tier-1.svg',
  'Benefits-Sparkle-tier-2': 'Benefits-Sparkle-tier-3.svg',
  'Benefits-Sparkle-tier-3': 'Benefits-Sparkle-tier-2.svg',
  vector: 'Vector.svg',
  'PURPLE-PLCC-CARD': 'PLCC-CARD.svg',
  'store-event-new': 'loyalty-store-event.svg',
  'early-access-new': 'loyalty-early-access.svg',
  'expedited-order-new': 'loyalty-expedited-order.svg',
  'users-defined-new': 'loyalty-users-defined.svg',
  'free-gift-wrap-new': 'loyalty-free-gift-wrap.svg',
  'loyalty-birthday-cake-new': 'loyalty-loyalty-birthday-cake.svg',
  'bonus-points-new': 'loyalty-bonus-points.svg',
  'purple-app-dowanload': 'loyalty-app-dowanload.svg',
  'purple-comment-lines': 'loyalty-comment-lines.svg',
  'purple-facbook-outline': 'loyalty-facbook.svg',
  'purple-sms-ring': 'loyalty-sms-ring.png',
  'purple-X': 'loyalty-X.svg',
  'purple-child-avatar': 'loyalty-child-avatar.svg',
  'purple-envelope-open': 'loyalty-envelope-open.svg',
  'purple-home-with-heart': 'loyalty-home-with-heart.svg',
  'purpletask-completed': 'loyalty-task-completed.svg',
  'purple-birthday-cake': 'loyalty-birthday-cake.svg',
  'purple-task-completed': 'loyalty-task-completed',
  'purple-check': 'purple-check.svg',
  'purple-info': 'purple-info.svg',
  'fav-icon-red': 'fav-icon-red.png',
  'wishlist-shopping-bag': 'wishlist-shopping-bag.png',
  'wishlist-edit-icon': 'wishlist-edit-icon.png',
  'thin-plus-icon': 'thin-plus-icon.png',
  'wishlist-share-icon': 'wishlist-share-icon.svg',
};
